import React from "react";

import * as Sticker from "ds/Sticker";

class ServiceMetricsErrorBoundary extends React.Component<
  { children: React.ReactNode },
  {
    error: {
      message: string;
    } | null;
  }
> {
  static getDerivedStateFromError(
    error: {
      message: string;
    } | null
  ) {
    return { error };
  }

  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  render() {
    if (this.state.error) {
      if (this.state.error.message.startsWith("Metrics not available")) {
        return null;
      }

      return (
        <Sticker.Root priority="critical">
          <Sticker.Icon priority="critical" />
          <Sticker.Text>{this.state.error.message}</Sticker.Text>
        </Sticker.Root>
      );
    }

    return this.props.children;
  }
}

export default ServiceMetricsErrorBoundary;
